import loader from '../moduleLoader.js';

class NewsList {
    constructor(newslist) {
        this.newslist = newslist;
    }
    init() {
        window.addEventListener('FilterUpdate', (e) => {
        });
    }
}

loader.add('NewsList', NewsList);
export default NewsList;